import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CanMatch, convertToParamMap, Route, Router, UrlSegment, UrlTree} from '@angular/router';
import {SessionQuery} from '@app/core/state/session';
import {RightUtil} from '@app/core/util/right.util';

@Injectable()
export class RightGuard implements CanMatch {
  constructor(private sessionQuery: SessionQuery,
              private rightUtil: RightUtil,
              private snackbar: MatSnackBar,
              private router: Router) {
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {

    if (!this.sessionQuery.isLoggedIn()) {
      return this.getFullLoginURL(route, segments)
    }
    if (route.data && route.data.right) {
      if (this.rightUtil.hasRight(route.data.right)) {
        return true;
      } else if ((route.data.right.constructor === Array) && (this.rightUtil.hasAnyOfGivenRights(route.data.right))) {
        return true;
      } else {
        this.snackbar.open('Für diese Seite besitzen Sie keine Berechtigung!');
        return this.router.parseUrl('/home');
      }
    }
    return true;
  }

  private getFullLoginURL(route: Route, segments: UrlSegment[]): UrlTree {
    // Mögliche Queryparameter joinen
    const paramMap = convertToParamMap(this.router.getCurrentNavigation().extractedUrl.queryParams);
    const urlParams = new URLSearchParams();
    if (paramMap && paramMap.keys?.length > 0) {
      paramMap.keys.forEach(key => urlParams.append(key, paramMap.get(key)));
    }

    if (!segments || segments.length === 0) {
      let routePath = route.path;
      if (paramMap?.keys?.length > 0) { // queryparameter zur url hinzfügen
        routePath = `${routePath}?${urlParams.toString()}`;
      }
      return this.router.createUrlTree(['/login'],
        {queryParams: {routeAfterLogin: routePath}});
    } else {
      let routeSegment = segments.map(seg => seg.path).join('/');
      if (paramMap?.keys?.length > 0) { // queryparameter zur url hinzfügen
        routeSegment = `${routeSegment}?${urlParams.toString()}`;
      }

      return this.router.createUrlTree(['/login'],
        {queryParams: {routeAfterLogin: routeSegment}});
    }
  }
}
